import { useCallback, useEffect, useState } from "react";
import socketService from "../services/socketService";
import { fetchConversations } from "../utils/cmChatApi";
import {
  countUnreadChats,
  subscribeCmChatUnread,
} from "../utils/cmChatUnread";

export const useCareManagerChatBadge = (enabled = false) => {
  const [unreadChatCount, setUnreadChatCount] = useState(0);

  const refreshUnreadChatCount = useCallback(async () => {
    if (!enabled) {
      setUnreadChatCount(0);
      return;
    }

    try {
      const response = await fetchConversations();
      if (response?.success) {
        setUnreadChatCount(countUnreadChats(response.data || []));
      }
    } catch (error) {
      console.error("Error loading CM chat unread count:", error);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setUnreadChatCount(0);
      return undefined;
    }

    refreshUnreadChatCount();

    const unsubscribe = subscribeCmChatUnread((count) => {
      setUnreadChatCount(count);
    });

    const cmChatSocket = socketService.connectCmChat();
    const handleSocketMessage = () => {
      refreshUnreadChatCount();
    };

    cmChatSocket.on("cm-chat:message", handleSocketMessage);

    return () => {
      unsubscribe();
      cmChatSocket.off("cm-chat:message", handleSocketMessage);
    };
  }, [enabled, refreshUnreadChatCount]);

  return unreadChatCount;
};
